import { render, staticRenderFns } from "./SupportAvatarUpload.vue?vue&type=template&id=4657d8e0&"
import script from "./SupportAvatarUpload.vue?vue&type=script&lang=babel&"
export * from "./SupportAvatarUpload.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports